import { Component, OnDestroy, OnInit } from '@angular/core';
import { generateTransactionLink } from '@constants/networks';
import { ISupportedCoin } from '@http/interfaces/supported-coin';
import { ISignatureWallet } from '@http/interfaces/transaction';
import { WalletWeb3Service } from '@services/web3modal.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Observable, Subject, delay, takeUntil, tap } from 'rxjs';


@Component({
  selector: 'app-process-transaction',
  templateUrl: './process-transaction.component.html',
  styleUrl: './process-transaction.component.scss'
})
export class ProcessTransactionComponent implements OnInit, OnDestroy {
  private destroyed$ = new Subject<void>();

  // Outside state
  amount!: string;
  trxAddress!: string | null;
  coin!: ISupportedCoin; 
  
  signature$!: Observable<ISignatureWallet>
  isProccess = true;

  constructor(
    public bsModalRef: BsModalRef,
    private walletService: WalletWeb3Service,
  ) {
    this.signature$ = this.walletService.signature$ 
  }


  ngOnInit(): void {
    this.walletService.proccessBuyingError$
    .pipe(
      takeUntil(this.destroyed$),
      delay(600),
      tap((isError) => {
        if (isError) {
          this.bsModalRef.hide()
          this.walletService.proccessBuyingError$.next(false)
        }
      })
    ).subscribe();

    this.walletService.proccessBuying$
      .pipe(
        takeUntil(this.destroyed$),
        tap(isBuying => this.isProccess = isBuying),
        delay(3000),
        tap(() => {
          if (!this.isProccess) {
            this.walletService.signature$.next({ to: '', from: '', hash: '' })
            this.bsModalRef.hide();
          }
      })
    ).subscribe();
  
    this.walletService.signature$.pipe(
      takeUntil(this.destroyed$),
      tap((signature) => {
        this.trxAddress = generateTransactionLink(
          signature.hash,
          this.coin.chain_id
        );
      })
    ).subscribe()
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
